<template>
  <div class="page artists has-search" :class="filtersActive && filterNoticeDescription.length ? 'has-filter-notice' : ''">
    <div class="page-header">
      <button class="header-nav-btn" @click="$parent.$refs.nav.open()" aria-label="Open nav menu"></button>

      <span class="page-title"><span class="icon">Artists</span></span>
      <HeaderNav />

      <button class="header-filter" @click="openFilters">Filter &amp; Sort</button>
    </div>

    <div class="filter-notice" v-show="filtersActive && filterNoticeDescription.length">
      <p>Filtered by: <span>{{ filterNoticeDescription }}</span></p>
      <button class="clear" @click="clearFilters"></button>
    </div>

    <div class="page-search">
      <input type="text" v-model="search" v-on:keyup.enter="hideKeyboard" v-on:blur="hideKeyboard" v-on:focus="showKeyboard">
      <p class="input-placeholder" v-if="search.length === 0">Search</p>
      <button v-if="search.length" class="clear gray" @click="search = ''"></button>
    </div>


    <div class="page-content">
      <div class="page-container" :class="$root.app ? 'app' : ''">
        <!-- APP -->
        <div v-if="$root.app && !filtersActive && !hasSeenPageHelp" class="page-help">
          <div class="page-help-content">
            <p class="tip">Swipe left to add any artist to your &ldquo;Favorites.&rdquo; A colored bar indicates they have been saved. </p>
          </div>
        </div>
        <template v-if="$root.app">
          <ul class="list">
            <Cell v-for="artist in pages[currentPage]" :artist="artist" :key="artist.id" :onFavoritesPage="showFavorites"></Cell>
          </ul>
        </template>

        <!-- WEBSITE -->
        <template v-else>
          <div class="pagination top" v-if="pages.length > 1">
            <button class="prev" @click="changePage('prev')"><svg xmlns='http://www.w3.org/2000/svg' width='7.908' height='12.988'><path d='m.707 12.281 5.787-5.787L.707.707' fill='none' stroke-width='2'/></svg></button>

            <select v-model="currentPage" @change="changePage()">
              <option v-for="(page, index) in pages" :key="index" :value="index">Page {{index + 1}} of {{pages.length}}</option>
            </select>

            <button class="next" @click="changePage('next')"><svg xmlns='http://www.w3.org/2000/svg' width='7.908' height='12.988'><path d='m.707 12.281 5.787-5.787L.707.707' fill='none' stroke-width='2'/></svg></button>
          </div>

          <div v-if="artists.length" class="artists-grid">
            <button v-for="artist in pages[currentPage]" :key="artist.id" class="artist" @click="$router.push(`/participants/${artist.id}`)">
              <img v-if="artist.artwork.length && artist.artwork[0].images.length && artist.artwork[0].images[0].image" :src="artist.artwork[0].images[0].image.url" :alt="artist.artwork[0].images[0].image.alt">
              <img v-else-if="artist.headshot" :src="artist.headshot.url" :alt="artist.headshot.alt">
              <span class="artist-name">{{artist.tour_number}} {{artist.name}}</span>
              <span class="artist-medium"><i>{{artist.medium}}</i></span>
              <span class="artist-venue">{{artist.venue}}</span>
            </button>
          </div>
        </template>

        <p class="post-list" v-if="artists.length === 0 && (filtersActive || search.length)">No results</p>
        <p class="post-list" v-else-if="!$root.artistsLoaded">Loading...</p>
      </div>

      <div class="pagination bottom" v-if="pages.length > 1">
        <button class="prev" @click="changePage('prev')"><svg xmlns='http://www.w3.org/2000/svg' width='7.908' height='12.988'><path d='m.707 12.281 5.787-5.787L.707.707' fill='none' stroke-width='2'/></svg></button>

        <select v-model="currentPage" @change="changePage()">
          <option v-for="(page, index) in pages" :key="index" :value="index">Page {{index + 1}} of {{pages.length}}</option>
        </select>

        <button class="next" @click="changePage('next')"><svg xmlns='http://www.w3.org/2000/svg' width='7.908' height='12.988'><path d='m.707 12.281 5.787-5.787L.707.707' fill='none' stroke-width='2'/></svg></button>
      </div>
    </div>

    <Filters ref="filters" />
  </div>
</template>

<script>
import SubPageUtils from '../mixins/SubPageUtils';
import FiltersUtils from "../mixins/FiltersUtils";
import HeaderNav from '../components/HeaderNav';

import Cell from "../components/Cell";
import Filters from "../components/Filters";

export default {
  components: { HeaderNav, Cell, Filters },
  mixins: [SubPageUtils, FiltersUtils],
  data() {
    return {
      currentPage: 0,
    }
  },
  computed: {
    pages() {
      return _.chunk(this.artists, 30);
    },
    hasSeenPageHelp() {
      return localStorage.getItem('hasSeenPageHelp_participants');
    },
  },
  methods: {
    filtersChanged() {
      this.currentPage = 0;
    },
    changePage(page) {
      if (page === 'prev') {
        if (this.currentPage === 0) return;
        this.currentPage--;
      } else if (page === 'next') {
        if (this.currentPage === (this.pages.length - 1)) return;
        this.currentPage++;
      } else if (page) {
        this.currentPage = page;
      }

      window.scrollTo(0, 0);
    },
  },
  mounted() {
    setTimeout(() => {
      localStorage.setItem('hasSeenPageHelp_participants', 'yes');
    }, 2000);
  },
};
</script>

<style scoped lang="less">
@import '../css/variables';

.icon {
  background-image: url(../assets/img/icon-artists.svg);
  background-size: 18px 21px;
}

.artists-grid {
  display: grid;
  justify-items: stretch;
  align-items: start;
  grid-auto-columns: 1fr;
  grid-column-gap: 20px;
  grid-row-gap: 40px;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: auto;
  padding: 50px 0;
  @media (max-width: 991px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (max-width: 479px) {
    grid-template-columns: 1fr;
  }
  .artist {
    text-align: center;
    text-decoration: none;
    &:hover {
      .artist-name {
        color: @themeColor3;
      }
    }
    img {
      display: block;
      margin: 0 auto 10px auto;
      width: auto;
      max-width: 100%;
      height: 200px;
      object-fit: cover;
      object-position: center;
    }
    span {
      display: block;
      margin-bottom: 5px;
      color: #000;
    }
    .artist-name {
      font-family: @fontSecondary;
      font-size: 24px;
    }
  }
}

.pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 50px 0;
  &.top {
    padding: 25px 0 0 0;
  }
  button {
    width: 44px;
    height: 44px;
    margin: 0;
    padding: 0;
    text-align: center;
    font-family: @fontSecondary;
    color: #000;
    &:last-child {
      margin-right: 0;
    }
    &.prev {
      svg {
        transform: rotate(180deg);
      }
    }
    &.next {
      transform: translateX(-5px);
    }
    path {
      stroke: @themeColor1;
    }
  }
  select {
    margin: 0 15px;
    transform: translateY(-2px);
    font-family: @fontSecondary;
    font-size: 16px;
    color: #000;
    appearance: none;
    background-color: transparent;
    border: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Artists.vue